module.exports = __webpack_public_path__ + "img/ranking.cd7b7fc4.png";